/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {UserService} from '../shared/services/user.service';
import {DependencyLoadNotifierService} from '../shared/services/dependency-load-notifier/dependency-load-notifier.service';

@Injectable({
    providedIn: 'root'
})
export class WelcomePageGuard  {
    constructor(private userService: UserService,
                private dependencyLoadNotifier: DependencyLoadNotifierService,
                private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const isAllowedSubject = new ReplaySubject<boolean>(1);

        this.dependencyLoadNotifier.onReady.subscribe(() => {
            this.emitIsAllowed(isAllowedSubject);
        });

        return isAllowedSubject.asObservable();
    }

    private emitIsAllowed(isAllowedSubject: Subject<boolean>): void {
        if (!this.userService.isFirstAccess) {
            this.router.navigate(['/']);
        }

        isAllowedSubject.next(this.userService.isFirstAccess);
        isAllowedSubject.complete();
    }
}
